import { takeLatest, put, select } from 'redux-saga/effects';
import { PCStoreJsBridge } from '../nativeapi';
import {
  APKS_REQ_INSTALL_LIST_START,
  APKS_REQ_INSTALL_START,
  APKS_REQ_RUN_START,
} from '../constants/anative';

import { DOWNLOAD_GET_SOFT_LIST_SUCCESS } from '../constants/downloadTask';
import { logNative } from '../utils/utils';
import { idText } from 'typescript';

function* fetchRunAndroidSoft({ soft }) {
  try {
    yield PCStoreJsBridge.openAndroidSoft(soft);
  } catch (error) {
    logNative('fetchRunAndroidSoft 错误', error);
  }
}

export function* watchFetchRunAndroidSoft() {
  yield takeLatest(APKS_REQ_RUN_START, fetchRunAndroidSoft);
}
